/**
 * Stage 7 — Projects / Quotes frontend feature registration.
 *
 * Adds one top-level nav entry and the list + detail routes. All routes
 * are gated by `projects:*` permissions so read-only users still see
 * the list but cannot edit lines, totals, or shares.
 */
import React, { lazy } from 'react'
import { Route } from 'react-router-dom'
import { ClipboardList } from 'lucide-react'
import { ProtectedRoute } from '@/components/ProtectedRoute'
import { lazyRoute } from '../routeHelpers'
import type { FrontendFeature } from '../types'

const ProjectsListPage = lazy(() => import('./pages/ProjectsListPage'))
const ProjectDetailPage = lazy(() => import('./pages/ProjectDetailPage'))

const feature: FrontendFeature = {
  navItems: [
    {
      path: '/projects',
      label: 'Projects',
      icon: ClipboardList,
      requiredPermissions: ['projects:read'],
    },
  ],
  routes: [
    <Route
      key="projects-list"
      path="/projects"
      element={
        <ProtectedRoute requiredPermissions={['projects:read']}>
          {lazyRoute(<ProjectsListPage />)}
        </ProtectedRoute>
      }
    />,
    <Route
      key="projects-detail"
      path="/projects/:id"
      element={
        <ProtectedRoute requiredPermissions={['projects:read']}>
          {lazyRoute(<ProjectDetailPage />)}
        </ProtectedRoute>
      }
    />,
  ],
}

export default feature
